@if (fullscreen) {
    <div class="fullscreen-overlay">
        <div class="fullscreen-center">
            <mat-spinner></mat-spinner>
        </div>
    </div>
}@else if (overlay) {
    <div class="overlay">
        <div class="center">
            <mat-spinner></mat-spinner>
        </div>
    </div>
}@else {
    <div class="center">
        <mat-progress-spinner
            [diameter]="diameter"
            [mode]="mode"
            [color]="color"
            [strokeWidth]="strokeWidth"
            [value]="value">
        </mat-progress-spinner>
    </div>
}
